import { Fragment, useEffect } from "react";

export const GreetingContainer = ({ reference, orderStatus, isTBA }) => {
  return (
    <Fragment>
      {isTBA && isTBA == true ? (
        <div className="col-md-8 offset-md-2">
          <div className="orderSummited text-center">
            <svg className="checkmark" viewBox="0 0 60 60">
              <circle cx={30} cy={30} r={30} fill="#ff9327" />
              <path className="tick" d="M18 31 L26 39 L42 22" />
            </svg>
            <div className="order-summited-info order-fright">
              <h1>Order Submitted, We will get back to you shortly</h1>
              <p>Order Ref: #{reference}</p>
              <div className="summited-orderTracking mt-2">
                <div className="orderTracking-details orderTracking-freightPrice text-left">
                  <i className="fa-solid fa-circle-exclamation" />
                  <p>
                    Your order has been submitted as a quote pending freight charges. We'll update it with the freight
                    costs and get back to you shortly with the details.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-lg-12">
          <div className="orderSummited text-center">
            <svg className="checkmark" viewBox="0 0 60 60">
              <circle cx={30} cy={30} r={30} fill="#009929" />
              <path className="tick" d="M18 31 L26 39 L42 22" />
            </svg>
            <div className="order-summited-info">
              <h1>{orderStatus == "Completed" ? "Order Completed!" : "Order Submitted, Thank You!"}</h1>
              <p>Confirmation #{reference}</p>
              <p>Your order has been successfully completed.</p>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
